import React from 'react';
import { useTranslation } from 'react-i18next';

import './MiddleItem.scss';

export const MiddleItem = () => {
  const [t] = useTranslation();

  return (
    <div className="moderator-finden-middle-item">
      <div className="moderator-finden-middle-item-left-container">
        <div className="title-snippet">
          {t('ModeratorFinder.middleItem.title')}
        </div>
        <div className="description">
          {/* prettier-ignore */}
          <div className="moderator-finden-middle-item-left-container-description">
            {t('ModeratorFinder.middleItem.description')}
          </div>
          {/* prettier-ignore */}
          <div className="moderator-finden-middle-item-left-container-description">
            {t('ModeratorFinder.middleItem.description2')}
          </div>
        </div>
      </div>
      <div className="moderator-finden-middle-item-right-container" />
    </div>
  );
};

export default MiddleItem;
